export default __webpack_public_path__ + "static/media/phcnEko.ce7a0a44.svg";